import DashboardCardOptionItem from "@/components/ReportDashboard/Shared/DashboardCardOptionItem"
import { useDashboardCardOptions } from "@/components/ReportDashboard/Shared/useDashboardCardOptions"
import { FADashboardType } from "@/constants/ReportDashboard/dashboards/dashboard-types"
import { useTheme } from "@/contexts/RADashboardThemeContext/hooks"
import { RADashboardLayout } from "@/interfaces/raDashboard.interface"
import { Box, Divider, List, Paper, Typography } from "@mui/material"
import React from "react"

type DashboardCardPaletteProps = {
  layout: RADashboardLayout
  selectedTab: string
  isLocked: boolean
  setLayout: (newLayout: RADashboardLayout) => void
  dashboardType: FADashboardType
}

const DashboardGuiPalette: React.FC<DashboardCardPaletteProps> = ({ layout, selectedTab, isLocked, setLayout, dashboardType }) => {
  const theme = useTheme()
  const { uniqueCards, datapointCards, isCardInUse, addCard } = useDashboardCardOptions({
    layout,
    selectedTab,
    setLayout,
    dashboardType,
  })

  const containerStyle = {
    width: 220,
    flexShrink: 0,
    position: 'relative',
    borderRadius: '8px',
    backgroundColor: theme.inputBackground,
    borderColor: theme.border,
  }

  return (
    <Paper
      variant="outlined"
      sx={containerStyle}
    >
      <Box sx={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" sx={{ px: 2, py: 1.5, fontWeight: 500 }}>
        Cards
      </Typography>
      <Divider />
      <List sx={{ overflowY: 'auto', flex: 1, minHeight: 0, px: 1, pt: 1, pb: 0.5 }}>
        {uniqueCards.map((cardId) => (
          <DashboardCardOptionItem
            key={cardId}
            cardId={cardId}
            inUse={isCardInUse(cardId)}
            disabled={isCardInUse(cardId) || isLocked}
            tooltipPlacement="left"
            onClick={() => addCard(cardId)}
          />
        ))}

        <Typography variant="subtitle2" sx={{ py: 1.5, fontWeight: 400 }}>
          Single Datapoints
        </Typography>

        {datapointCards.map((cardId) => (
          <DashboardCardOptionItem
            key={cardId}
            cardId={cardId}
            inUse={isCardInUse(cardId)}
            disabled={isCardInUse(cardId) || isLocked}
            tooltipPlacement="left"
            onClick={() => addCard(cardId)}
          />
        ))}
      </List>
      </Box>
    </Paper>
  )
}

export default DashboardGuiPalette
